<template>
    <div class="site-switch">
        <div class="site-switch__current" @click="open = !open">
            <span v-html="currentLocation"></span> Location
            <span class="site-switch__chevron"></span>
        </div>
        <div class="site-switch__options" v-if="open">
            <div class="site-switch__option" v-for="option in options" v-html="option.name" @click="gotosite(option.url)"></div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                open: false
            }
        },

        props: [
            'options',
            'currentLocation'
        ],

        methods: {
            gotosite(url) {
                window.location = url;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// SiteSwitch.vue?77d1e3cc